import {
  STRATEGIC_CONTEXT_FETCH_REQUEST,
  STRATEGIC_CONTEXT_FETCH_SUCCESS,
  STRATEGIC_CONTEXT_FETCH_FAILURE,
  STRATEGIC_CONTEXT_SAVE_REQUEST,
  STRATEGIC_CONTEXT_SAVE_SUCCESS,
  STRATEGIC_CONTEXT_SAVE_FAILURE,
  STRATEGIC_CONTEXT_UPDATE_FIELD,
  STRATEGIC_CONTEXT_CLEAR
} from './strategiccontextActions'

const INITIAL_STATE = {
  posicionamento: '',
  restricoes: '',
  prioridades: '',
  loading: false,
  loaded: false,
  saving: false,
  error: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case STRATEGIC_CONTEXT_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      }

    case STRATEGIC_CONTEXT_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        posicionamento: action.payload.posicionamento,
        restricoes: action.payload.restricoes,
        prioridades: action.payload.prioridades
      }

    case STRATEGIC_CONTEXT_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload
      }

    case STRATEGIC_CONTEXT_SAVE_REQUEST:
      return {
        ...state,
        saving: true,
        error: null
      }

    case STRATEGIC_CONTEXT_SAVE_SUCCESS:
      return {
        ...state,
        saving: false,
        error: null,
        posicionamento: action.payload.posicionamento || '',
        restricoes: action.payload.restricoes || '',
        prioridades: action.payload.prioridades || ''
      }

    case STRATEGIC_CONTEXT_SAVE_FAILURE:
      return {
        ...state,
        saving: false,
        error: action.payload
      }

    case STRATEGIC_CONTEXT_UPDATE_FIELD:
      return {
        ...state,
        [action.payload.field]: action.payload.value
      }

    case STRATEGIC_CONTEXT_CLEAR:
      return {
        ...INITIAL_STATE
      }

    default:
      return state
  }
}